import { administrationTitle } from './titles/administration';
import { homeTitle } from './titles/home';
import { mfisTitle } from './titles/mfis';
import { reportTitle } from './titles/report';

export const routesTitle = [...homeTitle, ...mfisTitle, ...reportTitle, ...administrationTitle];
